import { useState } from 'react';
import { validateFilesForUpload } from '../utils/fileValidation';

const useXFileUpload = ({ accept, maxSize, shouldValidate = true, onFileSelect }) => {
  const [fileErrorList, setFileErrorList] = useState([]);

  const handleChange = async (event) => {
    const files = Array.from(event.target.files || []);
    const path = event.target.value;
    // cleared up front, or re-picking a file the caller rejected fires no second change event
    event.target.value = '';

    if (!shouldValidate) {
      if (files.length > 0) {
        onFileSelect?.({ file: files, path });
      }
      return;
    }

    const { validFiles, errorList } = await validateFilesForUpload({
      files,
      accept,
      maxSize,
    });

    if (errorList.length) {
      setFileErrorList(errorList);
    }

    if (validFiles.length > 0) {
      onFileSelect?.({ file: validFiles, path });
    }
  };

  return { fileErrorList, setFileErrorList, handleChange };
};

export default useXFileUpload;
